module.exports = __webpack_public_path__ + "img/Graviety.19db0537.png";